import { Children, PropsWithChildren, cloneElement, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Button, ButtonProps } from '../../mui/Button';
import { Menu } from '../../mui/Menu';
import { IoMdArrowDropdown } from '../Icons/ion';

export interface ControllerButtonMenuProps extends ButtonProps {
  buttonText: string;
}

const useStyles = makeStyles(() => ({
  endIcon: {
    transition: 'all .25s ease-out',
    transitionProperty: 'transform',
    transform: 'rotate(0deg)',
  },
  endIconOpen: {
    transform: 'rotate(180deg)',
  },
}));

export function ControllerButtonMenu({
  buttonText,
  color = 'primary',
  onClick,
  children,
  ...other
}: PropsWithChildren<ControllerButtonMenuProps>) {
  const classes = useStyles();
  const [buttonEl, setButtonEl] = useState<HTMLElement | null>(null);
  const [showMenu, setShowMenu] = useState(false);

  const handleCloseMenu = () => {
    setShowMenu(false);
  };

  const handleButtonClick: React.MouseEventHandler<HTMLButtonElement> = (evt) => {
    setShowMenu(!showMenu);
    onClick && onClick(evt);
  };

  return (
    <span>
      <Button
        color={color}
        endIcon={<IoMdArrowDropdown className={clsx(classes.endIcon, showMenu && classes.endIconOpen)} />}
        onClick={handleButtonClick}
        ref={setButtonEl}
        variant='outlined'
        {...other}
      >
        {buttonText}
      </Button>
      {Children.count(children) ? (
        <Menu
          anchorEl={buttonEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          open={showMenu}
          transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          onClose={handleCloseMenu}
          onClick={handleCloseMenu}
        >
          {Children.map(children, (child) => cloneElement(child as JSX.Element, { color }))}
        </Menu>
      ) : null}
    </span>
  );
}
